import { Button, constants } from "@findemdev/maui";
import { DeleteCopy, StyledModal } from "../../RaasClientPortal.styled";

const { dimensions } = constants;
const DELETE_PROJECT_MODAL_WIDTH =
  Number.parseInt(dimensions.spacing["10"], 10) * 5 +
  Number.parseInt(dimensions.spacing["5"], 10);

interface IDeleteProjectModalProps {
  isDeleting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  projectName: string;
  visible: boolean;
}

export const DeleteProjectModal = ({
  isDeleting,
  onCancel,
  onConfirm,
  projectName,
  visible,
}: IDeleteProjectModalProps) => (
  <StyledModal
    footer={[
      <Button disabled={isDeleting} key="cancel" onClick={onCancel}>
        Cancel
      </Button>,
      <Button key="delete" loading={isDeleting} onClick={onConfirm} type="primary">
        Delete
      </Button>,
    ]}
    onCancel={onCancel}
    title="Delete Project"
    visible={visible}
    width={DELETE_PROJECT_MODAL_WIDTH}
  >
    <DeleteCopy>
      Are you sure you want to delete <strong>{projectName}</strong>? This action
      cannot be undone.
    </DeleteCopy>
  </StyledModal>
);
